// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-n_hk","advertDetailParameterList__header":"c-n_hl","advertDetailParameterList__list":"c-n_hm"};